import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=2bd20844"
import script from "./Offline.vue?vue&type=script&lang=js"
export * from "./Offline.vue?vue&type=script&lang=js"
import style0 from "./Offline.vue?vue&type=style&index=0&id=2bd20844&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports